import React from 'react';
import { PopupModal } from '../../../Modals/Index';

import { ImagesLibrary } from '../..';
const Index = ({ state, setStateFalse, setImage }) => {
    return (
        <PopupModal setStateFalse={setStateFalse} state={state}>
            <div className="popupConatiner">
                <ImagesLibrary setStateFalse={setStateFalse} alt={true} setImage={setImage} />
            </div>
        </PopupModal>
    );
};

export default Index;
